import { createContext, useContext, useState, useEffect } from "react";

const SongContext = createContext(null);

const STORAGE_KEY = "daremusics_song_state";

export function SongProvider({ children }) {
  const [lyricsData, setLyricsData] = useState(null);
  const [editedLyrics, setEditedLyrics] = useState("");
  const [editedPrompt, setEditedPrompt] = useState("");
  const [songData, setSongData] = useState(null);
  const [concept, setConcept] = useState("");

  // Load from sessionStorage on mount
  useEffect(() => {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) {
        const data = JSON.parse(saved);
        if (data.lyricsData) setLyricsData(data.lyricsData);
        if (data.editedLyrics) setEditedLyrics(data.editedLyrics);
        if (data.editedPrompt) setEditedPrompt(data.editedPrompt);
        if (data.songData) setSongData(data.songData);
        if (data.concept) setConcept(data.concept);
      }
    } catch {}
  }, []);

  // Save to sessionStorage on change
  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        lyricsData, editedLyrics, editedPrompt, songData, concept
      }));
    } catch {}
  }, [lyricsData, editedLyrics, editedPrompt, songData, concept]);

  const clearAll = () => {
    setLyricsData(null);
    setEditedLyrics("");
    setEditedPrompt("");
    setSongData(null);
    setConcept("");
    sessionStorage.removeItem(STORAGE_KEY);
  };

  return (
    <SongContext.Provider value={{
      lyricsData, setLyricsData,
      editedLyrics, setEditedLyrics,
      editedPrompt, setEditedPrompt,
      songData, setSongData,
      concept, setConcept,
      clearAll
    }}>
      {children}
    </SongContext.Provider>
  );
}

export function useSong() {
  return useContext(SongContext);
}
